import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Component as Form } from "@repoflow/form-schema";
import * as list from "@repoflow/form-schema/widgets/list";

export const Fields = ({ target, schema, values, widgets, config }) => {
  const [key, setKey] = useState(0);

  const formProps = {
    readOnly: true,
    schema,
    target,
    config,
    values,
    widgets,
  };

  useEffect(() => {
    setKey(key + 1);
  }, [values]);

  return <Form key={key} {...formProps} />;
};

// Renders `rows` as an array of /Row, and `items.type` there is undefined
// rather than "string", so resolve() sends it to the `list` widget. `list` is
// not in @repoflow/form-schema's built-in table, so Table registers it here —
// callers should not have to know that. No app uses Table today; if one starts,
// this is what keeps it from throwing "widget.missing:list" at render.
export const Table = (props) => {
  const { schema, config, widgets } = props;

  return (
    <Fields
      {...props}
      widgets={{ list, ...widgets }}
      schema={[
        ...schema,
        {
          id: "/Table",
          type: "object",
          properties: {
            rows: { type: "array", items: { $ref: "/Row" } },
          },
        },
      ]}
      target={{ $ref: "/Table" }}
      config={{
        ...config,
        "/Table": {
          fields: [
            {
              property: "rows",
              layout: "wide",
              label: "",
              hideEditControl: true,
            },
          ],
        },
      }}
    />
  );
};
